import AppDispatcher from './../flux/AppDispatcher';
import SlideOutTabConstants from './../constants/SlideOutTabConstants';
var dispatcher = AppDispatcher.get(SlideOutTabConstants.DISPATCHER);

var SlideOutTabActions = {

    open(setId: string, tabId: string): void {
        dispatcher.dispatch({
            actionType: SlideOutTabConstants.OPEN,
            tabId: tabId,
            setId: setId
        });
    },

    close(setId: string, tabId: string): void {
        dispatcher.dispatch({
            actionType: SlideOutTabConstants.CLOSE,
            tabId: tabId,
            setId: setId
        });
    },

    flash(setId: string, tabId: string): void {
        dispatcher.dispatch({
            actionType: SlideOutTabConstants.FLASH,
            tabId: tabId,
            setId: setId
        });
    },
}

export default SlideOutTabActions;